import { css } from '@emotion/react';
import type { ColorResult } from '~/_shared/components/colorPicker/colorPicker.types';

const UNIT_INPUT_WIDTH = 110;

export const placesToolContainerStyle = css({
  cursor: 'default',
});

export const formStyle = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  padding: 16,
});

export const distanceStyle = css({
  alignItems: 'flex-end',
  display: 'flex',
  gap: 12,
});

export const sliderStyle = css({
  paddingBottom: 16,
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: '0%',
});

export const unitStyle = css({
  flexGrow: 0,
  flexShrink: 0,
  flexBasis: UNIT_INPUT_WIDTH,
});

export const settingStyle = css({
  display: 'flex',
  flexDirection: 'column',
  fontSize: 14,
  gap: 4,
});

export const labelStyle = css({
  fontSize: 14,
  textTransform: 'uppercase',
});

export const exampleStyle = css({
  fontSize: 12,
  textTransform: 'none',
});

export const hideStyle = css({
  visibility: 'hidden',
});

export const buttonStyle = css({
  height: 48,
  marginTop: 8,
  width: '100%',
});

export const placesSearchItemPanelStyle = css({
  padding: 0,
});

export const placesToolAlertStyle = css({
  marginTop: 8,
});

export const placeCircleStyle = ({
  backgroundColor,
  color,
}: {
  backgroundColor: ColorResult;
  color: ColorResult;
}) => css({
  width: 20,
  height: 20,
  borderRadius: '50%',
  backgroundColor: backgroundColor.hex,
  color: color.hex,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 14,
});

export const placeDistanceLabelStyle = ({
  backgroundColor,
  color,
}: {
  backgroundColor: ColorResult;
  color: ColorResult;
}) => css({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: backgroundColor.hex,
  borderRadius: '4px',
  boxSizing: 'border-box',
  color: color.hex,
  fontSize: '12px',
  fontWeight: 500,
  height: '16px',
  padding: '4px',
});
